<template>
	<ul class="ContinentFilterWrapper">
		<li v-for="item in continentFilterOptions">
			<Checkbox
				:filterKey="key"
				:optionName="item.optionName"
				:optionValue="item.optionValue"
			/>
		</li>
	</ul>
</template>

<script lang="ts" src="./ContinentFilter.ts"></script>
<style lang="scss" scoped src="./ContinentFilter.scss"></style>
